import React from 'react'

const Header = () => {
  return (
    <nav> Get Ready to Complete TODAY GOALS</nav>
  )
}

export default Header;